import { createAuthClient } from "better-auth/react";
import { phoneNumberClient, magicLinkClient } from "better-auth/client/plugins";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:7001";

export const authClient = createAuthClient({
	baseURL: API_URL,
	plugins: [phoneNumberClient(), magicLinkClient()],
});
